exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-form-item[data-v-b03482e0]  .el-form-item__label{color:#000;text-align:left;font-size:16px;font-weight:bold}", ""]);

// exports
